/**
 * Private access settings (platform scope): the public certificate record check.
 *
 * Wire shapes come from the generated contract; the form schema is UI-only.
 */

import { z } from "zod";
import { certificateRecordCheckSchema, certificateRecordCheckUpdateSchema } from "@/generated/certificate-record-contract";

export { certificateRecordCheckSchema, certificateRecordCheckUpdateSchema };

export type CertificateRecordCheck = z.infer<typeof certificateRecordCheckSchema>;
export type CertificateRecordCheckUpdate = z.infer<typeof certificateRecordCheckUpdateSchema>;

/** The form: on or off, and a key typed in this session (never read back from the server). */
export const certificateRecordCheckFormSchema = z
  .object({
    enabled: z.boolean(),
    api_key: z.string().trim().max(512),
  })
  .superRefine((value, ctx) => {
    if (value.enabled && value.api_key.length > 0 && value.api_key.length < 8) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["api_key"], message: "That does not look like a Cert Spotter API key." });
    }
  });

export type CertificateRecordCheckForm = z.infer<typeof certificateRecordCheckFormSchema>;
